var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var focus = {
    content: '""',
    borderRadius: '1000px',
    position: 'absolute',
    top: '-4px',
    bottom: '-4px',
    left: '-4px',
    right: '-4px',
    zIndex: -1,
};
export default {
    default: {
        color: 'neutral_0',
        borderRadius: '4px',
        'input:checked + &': {
            bg: 'primary_2',
            border: 'none',
            borderColor: 'transparent',
        },
        'input:focus + &::before': __assign(__assign({}, focus), { bg: 'primary_4' }),
    },
    primary: {
        color: 'primary_2',
        borderRadius: '4px',
        'input:checked + &': {
            bg: 'neutral_0',
        },
        'input:focus + &::before': __assign(__assign({}, focus), { bg: 'primary_3' }),
    },
    radio: {
        color: 'primary_2',
        borderRadius: '20px',
        'input:checked + &': {
            bg: 'neutral_0',
            border: '1px solid',
            borderColor: 'primary_2',
        },
    },
};
